import Container, { Service } from 'typedi';

import {
    IAuthenticationResult,
    IAutoLoginModel,
    IAutoLoginResponseModel,
    ICrossAutoLoginModel,
    IAuthenticationService,
    IAutologinAuthenticationService,
    IExecuteWithAnalyticsResult,
} from '../models';
import { AuthenticationFlowType } from '../enums';
import { WindowToken } from '../../../injection-tokens';
import { CrossAutoLoginDataBuilder } from './cross-autologindata.builder.service';
import { UrlUtils } from '../../utils/urlUtils';
import { AuthenticationService } from './authentication.service';
import { AutoLoginAuthenticationService } from './autologin-authentication.service';

@Service()
export class CrossAuthenticationService {
    private readonly _autoLoginAuthenticationService: IAutologinAuthenticationService;
    private readonly _window: Window;
    private readonly _authenticationService: IAuthenticationService;
    private readonly _crossAutoLoginDataBuilder: CrossAutoLoginDataBuilder;
    private readonly _urlUtils: UrlUtils;

    constructor() {
        this._window = Container.get(WindowToken);
        this._crossAutoLoginDataBuilder = Container.get(CrossAutoLoginDataBuilder);
        this._urlUtils = Container.get(UrlUtils);
        this._authenticationService = Container.get(AuthenticationService);
        this._autoLoginAuthenticationService = Container.get(AutoLoginAuthenticationService);
    }

    public autoLogin = async (): Promise<IAuthenticationResult<IAutoLoginResponseModel>> => {
        const loginResult: IExecuteWithAnalyticsResult<IAutoLoginResponseModel> =
            await this._authenticationService.executeWithAnalytics(
                AuthenticationFlowType.Cross,
                async (): Promise<IAuthenticationResult<IAutoLoginResponseModel>> => {
                    this._saveSourceProductPackage();
                    const autoLoginData: IAutoLoginModel = await this._createAutoLoginData();
                    return this._autoLoginAuthenticationService.autoLogin(autoLoginData);
                },
                true,
            );
        await this._authenticationService.startOfferingAuthentication(loginResult);
        return loginResult?.result;
    };

    private _createAutoLoginData = async (): Promise<ICrossAutoLoginModel> => {
        const urlSearchParams = new URLSearchParams(this._window.location.search);

        const autoLoginData = await this._crossAutoLoginDataBuilder.Build(urlSearchParams);

        return autoLoginData;
    };

    private _saveSourceProductPackage = () => {
        const sourceProductPackage = this._urlUtils.getParameterByName('SourceProductPackage');

        if (sourceProductPackage) {
            this._window.NightlyLimitAutoLoginSourceProductPackage = sourceProductPackage;
        }
    };
}
